module.exports = __webpack_public_path__ + "static/media/MTL_BASE_SYNTH2.310dfbb9.png";